/**
 * Configuration Setting Action Types
 *
 * All Redux action type constants for the Configuration Setting page.
 */

const ConfigurationApiTypes = {
  // ─── Programs ───────────────────────────────────────────────────────────────
  // Retrieve all program configurations (list page)
  GET_PROGRAMS_REQUEST: "GET_PROGRAMS_REQUEST",
  GET_PROGRAMS_SUCCESS: "GET_PROGRAMS_SUCCESS",
  GET_PROGRAMS_FAILURE: "GET_PROGRAMS_FAILURE",

  // Retrieve a single program's full configuration + target settings
  GET_PROGRAM_DETAIL_REQUEST: "GET_PROGRAM_DETAIL_REQUEST",
  GET_PROGRAM_DETAIL_SUCCESS: "GET_PROGRAM_DETAIL_SUCCESS",
  GET_PROGRAM_DETAIL_FAILURE: "GET_PROGRAM_DETAIL_FAILURE",

  // Create (onboard) a new program with basic info + target settings
  CREATE_PROGRAM_REQUEST: "CREATE_PROGRAM_REQUEST",
  CREATE_PROGRAM_SUCCESS: "CREATE_PROGRAM_SUCCESS",
  CREATE_PROGRAM_FAILURE: "CREATE_PROGRAM_FAILURE",

  // Update program's basic info + target settings (single or batch)
  UPDATE_PROGRAMS_REQUEST: "UPDATE_PROGRAMS_REQUEST",
  UPDATE_PROGRAMS_SUCCESS: "UPDATE_PROGRAMS_SUCCESS",
  UPDATE_PROGRAMS_FAILURE: "UPDATE_PROGRAMS_FAILURE",

  // Disable (soft delete) program (single or batch)
  UPDATE_PROGRAMS_STATUS_REQUEST: "UPDATE_PROGRAMS_STATUS_REQUEST",
  UPDATE_PROGRAMS_STATUS_SUCCESS: "UPDATE_PROGRAMS_STATUS_SUCCESS",
  UPDATE_PROGRAMS_STATUS_FAILURE: "UPDATE_PROGRAMS_STATUS_FAILURE",

  // ─── Product Families ───────────────────────────────────────────────────────
  // Retrieve all active product families
  GET_PRODUCT_FAMILIES_REQUEST: "GET_PRODUCT_FAMILIES_REQUEST",
  GET_PRODUCT_FAMILIES_SUCCESS: "GET_PRODUCT_FAMILIES_SUCCESS",
  GET_PRODUCT_FAMILIES_FAILURE: "GET_PRODUCT_FAMILIES_FAILURE",

  // Create a new product family
  CREATE_PRODUCT_FAMILY_REQUEST: "CREATE_PRODUCT_FAMILY_REQUEST",
  CREATE_PRODUCT_FAMILY_SUCCESS: "CREATE_PRODUCT_FAMILY_SUCCESS",
  CREATE_PRODUCT_FAMILY_FAILURE: "CREATE_PRODUCT_FAMILY_FAILURE",

  // ─── Category Duplicate Check ──────────────────────────────────────────────
  CHECK_CATEGORY_DUPLICATE_REQUEST: "CHECK_CATEGORY_DUPLICATE_REQUEST",
  CHECK_CATEGORY_DUPLICATE_SUCCESS: "CHECK_CATEGORY_DUPLICATE_SUCCESS",
  CHECK_CATEGORY_DUPLICATE_FAILURE: "CHECK_CATEGORY_DUPLICATE_FAILURE",

  // ─── Program Options (from Auto Report) ────────────────────────────────────
  // Retrieve program/cm/location cascading options
  GET_PROGRAM_OPTIONS_REQUEST: "GET_PROGRAM_OPTIONS_REQUEST",
  GET_PROGRAM_OPTIONS_SUCCESS: "GET_PROGRAM_OPTIONS_SUCCESS",
  GET_PROGRAM_OPTIONS_FAILURE: "GET_PROGRAM_OPTIONS_FAILURE",

  // ─── Clear transient results/errors ─────────────────────────────────────────
  // Reset all result/error fields to prevent stale notifications on re-mount
  CLEAR_CONFIGURATION_RESULTS: "CLEAR_CONFIGURATION_RESULTS",
};

export default ConfigurationApiTypes;
